import Button from "../ui/Button";
import BookingSummary from "./BookingSummary";
import CustomerDetailsForm from "./CustomerDetailsForm";
import { BackButton } from "../ui/BackButton";
import PromoCodeCollapsible from "./PromoCodeCollapsible";
import { useAtomValue } from 'jotai';
import CampaignCodeInfo from './CampaignCodeInfo'; // add import
import { campaignCodeAtom, campaignValidationAtom, isOrderCreatingAtom } from './store';

type Props = {
  handlePrevStep: () => void;
  handleNextStep: () => void;
};

export default function Step2CustomerDetails({
  handlePrevStep,
  handleNextStep,
}: Props) {
  // Read campaign state
  const campaignCode = useAtomValue(campaignCodeAtom);
  const campaignValidation = useAtomValue(campaignValidationAtom);
  const isOrderCreating = useAtomValue(isOrderCreatingAtom);
  return (
    <div className="grid md:grid-cols-2 md:gap-0 gap-6 h-full">
      <div className="md:p-10 p-4 pt-0 flex flex-col gap-10">
        <BackButton
          handlePrevStep={handlePrevStep}
          className="md:hidden self-start"
          small
        />
        <div className="flex flex-col gap-4">
          {/* Show campaign success message when valid code applied */}
          <CampaignCodeInfo />
          {/* Customer form notifies when ready to move to payment */}
          <CustomerDetailsForm handleNextStep={handleNextStep} />
          {/* Show promo code only if no valid campaign code is active */}
          {(!campaignCode || campaignValidation.isValid !== true) && (
            <PromoCodeCollapsible />
          )}
        </div>
        <BackButton
          handlePrevStep={handlePrevStep}
          className="mt-auto hidden md:flex"
        />
      </div>
      <div className="bg-grey-light md:p-10 px-4 py-6 pb-16 md:rounded-xl flex flex-col gap-10">
        <BookingSummary />

        <Button
          type="submit"
          variant="primary"
          form="contactInformation"
          className="w-full mt-auto sticky bottom-10"
          disabled={isOrderCreating}
        >
          Continue to Payment
        </Button>
      </div>
    </div>
  );
}
